import gql from 'graphql-tag'

export default gql`
  query searchItems(
    $keyword: String
    $pageNumber: Int!
    $itemPerPage: Int!
    $itemReceivingKindIds: [Int!]
    $sortKey: String
    $sceneIds: [Int!]
    $categoryIds: [Int!]
    $stringLowerBudget: String
    $stringHigherBudget: String
  ) {
    searchItems(
      keyword: $keyword
      pageNumber: $pageNumber
      itemPerPage: $itemPerPage
      itemReceivingKindIds: $itemReceivingKindIds
      sortKey: $sortKey
      sceneIds: $sceneIds
      categoryIds: $categoryIds
      stringLowerBudget: $stringLowerBudget
      stringHigherBudget: $stringHigherBudget
    ) {
      items {
        id
        name
        usableLimitAt
        brand {
          id
          name
        }
        itemImage {
          id
          imageUrl
        }
        itemSkus {
          id
          name
          item {
            id
          }
          itemSkuDetail {
            id
            displayTaxType
          }
          itemSkuImage {
            id
            imageUrl
          }
          itemSkuAccountingCondition {
            id
            price
            shippingCost
          }
          itemSkuSalesCondition {
            id
            display
          }
        }
      }
      pagination {
        currentPage
        totalPages
        totalCount
      }
    }
  }
`
